module.exports = __webpack_public_path__ + "static/media/details-16-image-4.1b397ab2.jpg";